<template>
    <div class="flex justify-between w-full bg-regal-blue-100 rounded-xl p-6 space-x-6 items-center">
        <div class="flex items-center justify-center text-white w-20 h-20 cursor-pointer bg-regal-blue-700 rounded-full" v-if="progress">
            <svg v-if="progress" class="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
        <div v-if="!progress">
            <div class="flex items-center justify-center text-white w-20 h-20 cursor-pointer bg-regal-blue-700 rounded-full" @click="play" v-if="!playing">
                <svg class="fill-current w-6 h-6 -mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 22v-20l18 10-18 10z"/></svg>
            </div>
            <div class="flex items-center justify-center text-white w-20 h-20 cursor-pointer bg-regal-blue-700 rounded-full" @click="pause" v-if="playing">
                <svg class="fill-current w-12 h-12" viewBox="0 0 512 512"> <g> </g> <path d="M162.642 148.337h56.034v215.317h-56.034v-215.316z"/> <path d="M293.356 148.337h56.002v215.317h-56.002v-215.316z" /></svg>
            </div>
        </div>
        <div class="flex-1">
            <div class="text-regal-blue-700 font-medium">
                {{ name || Untitled }}
            </div>
            <div class="text-regal-blue-400 text-sm">
                <!-- {{ formattedDate }} -->
            </div>
        </div>
        <div class="text-gray-600">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
        </div>

        <audio controls class="hidden" ref="player">
          <source :src="file" :type="type">
        Your browser does not support the audio element.
        </audio>

    </div>
</template>

<script>
import { ref } from 'vue'

export default {
    setup (props) {
        let player = ref(null)
        let playing = ref(false)
        let file = ref(null)


        return { player, playing, file }
    },
    props: [ 'progress', 'file', 'name', 'date', 'duration', 'type'],
    methods: {
        play() {
            if (!this.player) {
                this.player = this.$refs.player
                this.player.onended = (e) => {
                    this.playing = false
                }
            }
            this.player.play()
            this.playing = true
        },
        pause() {
            if (!this.player.paused) {
                this.player.pause()
                this.playing = false
            }
        },
    },
    computed: {
        formattedDate() {
            let unix = Date.parse(this.date)
            const date = new Date(unix * 1000)
            return date.toLocaleString('en-US', {day: 'numeric'}) + ' ' +  date.toLocaleString('en-US', {month: 'short'})
        }
    }
}
</script>
